export default __webpack_public_path__ + "static/media/pexels-vlada-karpovich-4939659.53a6c2c8.jpg";